/**
 * Analytics API
 * RTK Query endpoints for analytics and dashboard data
 */

import { baseApi } from "./baseApi";

/**
 * Dashboard data interface
 */
export interface DashboardData {
	properties: {
		total: number;
		available: number;
		occupied: number;
		pending: number;
		maintenance: number;
		occupancy_rate: number;
	};
	payments: {
		total: number;
		pending: number;
		overdue: number;
		total_revenue: number;
		monthly_revenue: number;
	};
	maintenance: {
		total: number;
		pending: number;
		in_progress: number;
	};
	users: {
		total: number;
		tenants: number;
		technicians: number;
	};
}

/**
 * Analytics API endpoints
 */
export const analyticsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		/**
		 * Get dashboard KPIs
		 */
		getDashboard: builder.query<DashboardData, void>({
			query: () => ({
				url: "/analytics/dashboard/",
				method: "GET",
			}),
			providesTags: ["Analytics"],
		}),
	}),
});

/**
 * Export hooks for usage in functional components
 */
export const { useGetDashboardQuery, useLazyGetDashboardQuery } = analyticsApi;
